import { Model } from '@/models/Model'
import Property from '@/decorators/Property'
import { GeoJSON } from 'geojson'

export class Panorama extends Model {
	protected jsonApiType = 'panoramas'
	protected static pageSize = 25

	@Property()
	public largeImageURL?: string

	@Property()
	public smallImageURL?: string

	@Property()
	public position?: GeoJSON

	@Property()
	public cog?: number

	@Property()
	public altitude?: number

	@Property()
	public is360Image?: boolean
}
